import CardCarousel from './lib/card-carousel';
import ProductCarousel from './lib/product-carousel';
import RecipeCarousel from './lib/recipe-carousel';
import VideoHeader from './lib/video-header';
import replaceProductImages from './lib/product-images';

import './scss/product.scss';

CardCarousel.createFromSelector('.js-cards-carousel');
ProductCarousel.createFromSelector('.js-products-carousel');
RecipeCarousel.createFromSelector('.js-recipes-carousel');
VideoHeader.createFromSelector('.js-video-header');
replaceProductImages();
